"use strict";
/**
 * Core interfaces and types for feature flags system
 * Shared between frontend and backend implementations
 */
Object.defineProperty(exports, "__esModule", { value: true });
